import React from "react";
import PropTypes from "prop-types";
import { observer } from 'mobx-react';
import { QueryUtility } from "core/utils";
import { DateQueryPickerTemplate } from "themes/components";
import { QueryPickerStore } from 'core/stores';
import { useStores } from 'core/stores/StoreContext';

const DateQueryPicker = observer((props) => {
    const { timeZoneStore } = useStores();
    return <DateQueryPickerTemplate {...props} timeZone={timeZoneStore.timeZone} />;
});

DateQueryPicker.propTypes = {
    queryUtility: PropTypes.instanceOf(QueryUtility),
    store: PropTypes.instanceOf(QueryPickerStore),
    propertyName: PropTypes.string,
    onChange: PropTypes.func
};

export default DateQueryPicker;
